import { render, staticRenderFns } from "./LeaderboardLoader.vue?vue&type=template&id=35b83eaf&scoped=true&"
import script from "./LeaderboardLoader.vue?vue&type=script&lang=js&"
export * from "./LeaderboardLoader.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardLoader.vue?vue&type=style&index=0&id=35b83eaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b83eaf",
  null
  
)

export default component.exports